// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Google Fonts loaded non-blocking via <link> in index.html */
body {
  font-family: "DM Sans", sans-serif;
  /* Override Chakra's toast z-index CSS variable so toasts always appear above modals */
  --toast-z-index: 99999;
}

option {
  color: black;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/App.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,kCAAkC;EAClC,sFAAsF;EACtF,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd","sourcesContent":["/* Google Fonts loaded non-blocking via <link> in index.html */\nbody {\n  font-family: \"DM Sans\", sans-serif;\n  /* Override Chakra's toast z-index CSS variable so toasts always appear above modals */\n  --toast-z-index: 99999;\n}\n\noption {\n  color: black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
